// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:31:59.439Z
// Property: Phillips Pass (ID: 6767906449162905)
// Collections: 56 amenities, 8 floorplans (live), 37 photos, 6 POIs, 4 reviews, 6 virtual tours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162905",
  "property_external_id": "5056159",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/phillips-pass-houston-tx/5c8nbzn",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "phillips-pass",
  "property_name": "Phillips Pass",
  "property_website_url": "https://www.phillipspass.com/",
  "property_domain": null,
  "property_address": "2323 Eldridge Pkwy",
  "property_full_address": "2323 Eldridge Pkwy",
  "property_address_1": "2323 Eldridge Pkwy",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77077-5257",
  "property_address_zip": "77077",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Briar Village",
  "property_address_latitude": "29.7406411",
  "property_address_longitude": "-95.623137",
  "property_email": "phillipspass@alapts.com",
  "property_phone": "(281) 759-4064",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Phillips Pass in Houston, Texas! Choose from spacious one and two-bedroom floor plans. Enjoy top-notch amenities, including a refreshing pool, fitness center, and dog park. Find your new home today—browse our availability or schedule a tour to experience our welcoming community!",
  "property_long_description": "Welcome to Phillips Pass, your urban oasis nestled in the heart of Houston, Texas. Our charming apartment community offers a diverse selection of floor plans, including thoughtfully designed one and two-bedroom apartments that cater to your lifestyle needs. Each home is crafted to provide the perfect blend of comfort and style, ensuring you have a sanctuary to unwind in after a busy day.\n\nAt Phillips Pass, we pride ourselves on our exceptional amenities that elevate your living experience. Dive into relaxation at our sparkling pool, break a sweat in our state-of-the-art fitness center, or unwind in our luxurious spa. We offer added conveniences such as controlled access, elevator service, and a friendly concierge to assist you with all your needs.\n\nFor pet lovers, our community features a dedicated dog park and pet care services, ensuring your furry friends feel as at home as you do. Socialize and connect with neighbors at our inviting clubhouse, enjoy a game in our gameroom, or host a barbecue at our grill area while soaking in the sun on our putting greens. Stay connected with high-speed Wi-Fi throughout the property and take advantage of our EV charging stations and bicycle storage for a sustainable lifestyle.\n\nWith so much to offer, Phillips Pass is where community meets style. Don't miss out on finding your new home! Browse our availability or schedule a tour today to experience all that our vibrant community has to offer. Your perfect apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-9205-77b7-bcaf-9e1f27919581.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a resort-style swimming pool with palm trees and lounge chairs.",
    "public_id": "019cfddd-9205-77b7-bcaf-9e1f27919581",
    "storage_key": "property/6767906449162905/019cfddd-9205-77b7-bcaf-9e1f27919581.webp",
    "width": 1127,
    "height": 844
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "168",
  "property_year_built": "1997",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.80952380952381",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-87bf-770b-8fc4-6f52b7e27009.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddd-87bf-770b-8fc4-6f52b7e27009",
    "storage_key": "property/6767906449162905/019cfddd-87bf-770b-8fc4-6f52b7e27009.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-87bf-770b-8fc4-6f52b7e27009.webp",
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "708 - 1148",
  "property_sqft_min": "708",
  "property_sqft_max": "1148",
  "property_price_range": "1070.66 - 1506.66",
  "property_price_min": "1070.66",
  "property_price_max": "1506.66",
  "property_available_units": 2,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover your ideal living space at Phillips Pass in Houston, Texas! Choose from our spacious one and two-bedroom floor plans, perfectly designed for comfort. Explore our vibrant neighborhood and uncover local favorites and nearby attractions. **See what's around our community today and immerse yourself in the best of Houston!**",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Located about 20 miles west of Downtown Houston, Briar Village is an upscale neighborhood teeming with options for recreation, shopping, and dining. Residents have their pick of ample green spaces to enjoy the outdoors, with access to Terry Hershey Park, George Bush Park, McClendon Park, and Bear Creek Pioneers Park, among many others.\n\t\t\t\t\tBriar Village offers a distinct suburban feel with a bevy of convenient shopping centers in the neighborhood as well as quick access to sprawling malls like West Oaks Mall, Citycentre Plaza, and Memorial City Mall. Nestled between I-10 and Westpark Tollway, Briar Village is especially convenient for those working in Houston’s Energy Corridor.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Briar Village",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Phillips Pass in Houston, Texas! Discover our inviting one and two-bedroom floor plans, complemented by exceptional amenities like a pool, fitness center, and clubhouse. Enjoy pet-friendly spaces, EV charging, and more. Explore our amazing community amenities and apartment features today! Your perfect home awaits!",
  "property_applynow_blurb": "Discover your perfect home at Phillips Pass in Houston, Texas! Choose from spacious one- and two-bedroom floor plans, and enjoy top-notch amenities like a refreshing pool, fitness center, and dog park. Experience modern living with concierge services and EV charging. Apply now and lease online today!",
  "property_contactus_blurb": "Discover your ideal home at Phillips Pass in Houston, Texas! Choose from our thoughtfully designed one-bedroom and two-bedroom floor plans that fit your lifestyle. Ready to learn more? Have questions? Contact our leasing team today and take the first step towards your dream apartment!",
  "property_faqs_blurb": "Welcome to Phillips Pass in Houston, Texas! Explore our diverse floor plans, including spacious one and two-bedroom apartments. Have questions? Browse our FAQs page for answers about our community and discover the perfect home for you at Phillips Pass! Your dream apartment awaits!",
  "property_floorplans_blurb": "Discover your ideal living space at Phillips Pass in Houston, Texas! Our community offers thoughtfully designed one and two-bedroom floor plans to fit your lifestyle. Browse our available apartment homes today and find the perfect floor plan that suits your needs, all within a vibrant community you’ll love to call home!",
  "property_gallery_blurb": "Discover your ideal home at Phillips Pass in Houston, Texas! Explore our spacious one and two-bedroom floor plans, complemented by exceptional amenities like a stunning pool, fitness center, and dog park. Picture yourself living here—view our photo gallery and envision your perfect lifestyle today!",
  "property_interactivemap_blurb": "Discover your ideal home at Phillips Pass in Houston, Texas! Choose from spacious one and two-bedroom floor plans and enjoy exceptional amenities like a refreshing pool, state-of-the-art fitness center, and inviting clubhouse. Use our interactive community map to explore available apartments, view pricing, and secure your new oasis today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover the ideal living space at Phillips Pass in Houston, Texas, with versatile one and two-bedroom floor plans tailored to your needs. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy all the benefits of living in your new home together!",
  "property_residentaccess_blurb": "Welcome to Phillips Pass in Houston, Texas, where you can choose from spacious one and two-bedroom floor plans designed for comfort. Residents can easily manage their living experience by logging in to our resident portal. Access your account now to pay rent, schedule maintenance, and enjoy convenient living!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257804744",
  "property_scheduletour_blurb": "Discover your perfect home at Phillips Pass in Houston, Texas! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Schedule a tour today and see what our residents have to say about living in this vibrant community. Your ideal apartment awaits!",
  "property_thankyou_blurb": "Thank you for your interest in Phillips Pass, Houston's premier apartment community! Explore our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Stay tuned—our team will reach out shortly to assist you in finding your perfect home. Discover the best of Houston living with us!",
  "property_virtualtours_blurb": "Welcome to Phillips Pass in Houston, Texas! Explore our inviting one and two-bedroom floor plans designed for modern living. Experience the comfort and style of our apartment community. Take a virtual tour today and discover your new home among the vibrant surroundings! Don't miss out—start your journey now!",
  "property_copyright": "2025 All Rights Reserved. Phillips Pass",
  "property_seo_title_home": "Phillips Pass | Apartments in Houston, Texas",
  "property_seo_description_home": "Discover your ideal living space at Phillips Pass in Houston, Texas! Explore our variety of floor plans, including spacious one and two-bedroom apartments tailored to your lifestyle. Enjoy upscale amenities such as a sparkling pool, state-of-the-art fitness center, and a welcoming clubhouse. Pamper your pets with our pet care services and dog park, while eco-friendly EV charging stations cater to your green lifestyle. Experience modern comforts with controlled access, high-speed Wi-Fi, and more. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Houston, Texas",
  "property_seo_description_floorplans": "Discover your ideal living space at Phillips Pass in Houston, Texas! Explore our diverse floor plans, including inviting one-bedroom and spacious two-bedroom apartments. Browse our available apartment homes today and find the perfect floor plan that fits your lifestyle. Experience comfort and convenience at Phillips Pass!",
  "property_seo_title_amenities": "Amenities | Houston, Texas Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal living space at Phillips Pass in Houston, Texas! Our apartment community offers a variety of thoughtfully designed floor plans, including one and two-bedroom options. Enjoy resort-style amenities such as a sparkling pool, modern fitness center, and clubhouse. With perks like a pet play area, EV charging stations, and gaming room, we cater to all your lifestyle needs. Experience luxury living with controlled access, concierge services, and a relaxing spa. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, Texas",
  "property_seo_description_gallery": "Explore the stunning photo gallery of Phillips Pass, your dream apartment community in Houston, Texas. Discover our beautifully designed one and two-bedroom floor plans, complemented by top-notch amenities including a refreshing pool, state-of-the-art fitness center, and relaxing spa. Enjoy luxury living with concierge services, pet care options, and a vibrant clubhouse—all within a controlled-access environment. Picture yourself living here and experience the lifestyle you deserve. View all our captivating photos today!",
  "property_seo_title_virtualtours": "Virtual Tours | Phillips Pass Apartments",
  "property_seo_description_virtualtours": "\"Explore Phillips Pass in Houston, Texas! Our stunning one and two-bedroom floor plans cater to your lifestyle needs. Take a virtual tour of our vibrant apartment community today and discover your perfect home. Don’t miss out—experience all we have to offer now!\"",
  "property_seo_title_interactivemap": "Interactive Map | Phillips Pass Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Phillips Pass in Houston, Texas! Our interactive community map allows you to explore our thoughtfully designed one and two-bedroom floor plans. Enjoy resort-style amenities including a refreshing pool, state-of-the-art fitness center, clubhouse, and pet-friendly areas like our dog park and pet care services. Take advantage of controlled access, EV charging stations, and more. Begin your new lifestyle today—use our map to view available apartments and pricing!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, Texas",
  "property_seo_description_neighborhood": "Discover your perfect home at Phillips Pass in Houston, Texas! Explore our diverse floor plans, featuring one and two-bedroom apartments designed for ultimate comfort. Visit our Neighborhood page to see what's around our community, from local favorites to nearby points of interest. Embrace the vibrant lifestyle of Houston today!",
  "property_seo_title_contact": "Contact Us | Phillips Pass",
  "property_seo_description_contact": "Discover your ideal home at Phillips Pass in Houston, Texas. Explore our diverse floor plans, including spacious one and two-bedroom apartments designed for comfort and style. Have questions? Our dedicated leasing team is ready to assist you—contact us today to learn more about your future home!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, Texas",
  "property_seo_description_faqs": "Discover everything you need to know about living at Phillips Pass in Houston, Texas! Our FAQs page answers your questions about our spacious one and two-bedroom floor plans, luxurious amenities like a pool, fitness center, and pet-friendly spaces including a dog park and pet care services. Learn more about our controlled access, EV charging stations, and community features like the clubhouse and gameroom. Browse our FAQs now to find out why Phillips Pass is the perfect place for you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, Texas",
  "property_seo_description_reviews": "Discover why residents love calling Phillips Pass home in Houston, Texas! Explore our one and two-bedroom floor plans, and experience top-notch amenities like a pool, fitness center, and dog park. Enjoy concierge services, controlled access, and pet care facilities, including a dedicated play area. Engage with the community at our clubhouse, relax in the spa, or play a round on our putting greens. Check out our residents' reviews and see what makes Phillips Pass the perfect place for you. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, Texas",
  "property_seo_description_applynow": "Discover your perfect living space at Phillips Pass in Houston, Texas! Our community offers spacious one and two-bedroom floor plans, and a wealth of amenities designed for your lifestyle — including a refreshing pool, state-of-the-art fitness center, and a cozy clubhouse. Enjoy the convenience of controlled access, pet care services, EV charging, and a dedicated dog park. With Wi-Fi throughout the property and on-site concierge service, everything you need is at your fingertips! Ready to elevate your living experience? Apply now and find your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Phillips Pass",
  "property_seo_description_residentaccess": "\"Login to your resident portal at Phillips Pass in Houston, Texas! Easily pay rent, schedule maintenance, and manage your apartment needs all in one place. Access your convenience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Phillips Pass",
  "property_seo_description_referafriend": "\"Discover the joy of community at Phillips Pass in Houston, Texas! Refer a friend today and unlock exclusive benefits. Great friends make great neighbors—share the love and enjoy the perks of living together in our vibrant apartment community!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Phillips Pass",
  "property_seo_description_scheduletour": "\"Experience upscale living at Phillips Pass in Houston, Texas! Schedule a tour today to explore our modern apartments and vibrant community amenities. Discover your new home!\"",
  "property_seo_title_privacy": "Privacy Policy | Phillips Pass",
  "property_seo_description_privacy": "\"Discover the commitment to your privacy at Phillips Pass Apartments in Houston, Texas. We prioritize your security and transparency. View our privacy policy to learn how we protect your information and ensure a safe living experience.\"",
  "property_seo_title_accessibility": "Website Accessibility | Phillips Pass",
  "property_seo_description_accessibility": "\"Discover how Phillips Pass in Houston, Texas champions digital inclusion with our comprehensive Accessibility Statement. We prioritize equal access for all residents and visitors. Explore our commitment to creating an inclusive community today!\"",
  "property_seo_title_sitemap": "Sitemap | Phillips Pass",
  "property_seo_description_sitemap": "Explore the comprehensive sitemap for Phillips Pass in Houston, Texas! Discover floor plans, amenities, and community features that make our apartment community the perfect home. View our website sitemap today for easy navigation!",
  "property_seo_title_thankyou": "Thank You | Phillips Pass",
  "property_seo_description_thankyou": "Thank you for your interest in Phillips Pass, Houston's premier apartment community! One of our team members will be in touch shortly to assist you with your inquiry. Experience luxury living and vibrant amenities in the heart of Houston!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1784584424943",
  "amenities": [
    {
      "id": "ec_e05298a33a281fe80269109a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f01846048e631ca2fd0e6c60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb9b789303b6290dad75f5de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0726f2319053867d80a9cbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Car Charging Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_faa9b590299820de2ded720d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f5feaacebc4cafee5e21c096",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_493e4656f4ce58973416abff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e46b77bd54aeff867b8df55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-Up",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_295f49ad2c4a629a9b5f8148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cec6cea4ca6820b66a0a9fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39e8322f4a883c2a57af9677",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60a3ee9379143fa59877f26a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcd387e97931a6e530a0d41d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b40fb5bfa0f5d59eaaf6628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bc4b89702445f01a4ae2635",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e0a76fabb5a85250b3668d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "2-Inch Blinds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3ffc6b56a1465c7b06aa871b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "9` Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee391f8a47b624391fb06d1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a0946fe694893c45451bdc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Amp Fit Machine",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df758ade46b8f6c76935e4de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Built-In Microwaves",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6cccee468f8326094d143dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Controlled Access Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76acd68f8118707cb1090597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49ef38a2b70d3bc2776c3a9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e9f8bfb09476f6740c9b3d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Digital Moving Concierge Services by Updater",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2eaaa89f2e670495f8fd1462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e651b20b35c1ecf75a1ddc14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "First Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c19a76b47f9b9e3d5bfa0e42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-Size Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce34f6d79de401b931207b8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Garden Style Tubs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d1da392874b7bc819c5dd91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Generous Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8895a411158fbc75fbfaa055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen Pantries",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b63b7302e8d3b66e81033328",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Parcel Pending Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f1d9a902b92b44b54f53744",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Picnic Area w/ BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8d9d0faf9f51089f9dc9f17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Premium Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fa58eff4be81bfab74fdfb2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios and Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c2359c9c2dd97d03ffa0bf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident Clubhouse w/ WFH Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12b247fb3267d22ea1417bff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Third Floor",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f655d85ed2716f265649c28d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Burning Fireplaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56059fb035046e06b22ecbe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d96e928aa62ae2a70c91612",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71567250ea3b15947bc86770",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e8569b1d4d0805df65e8c2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9302d15a223a9641aa6a5c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6e9d5c7c9420fcc0bb96bfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d41db1abb58d1ef4f3e70d6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Satellite TV",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bcfe7aa4016bb8ae7fe7c68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92ca1aef1aa9cd6929f9370e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e73051eb05067c706be55ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c765f693e3b4a82eca5ea6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91378759155d2369e8b311b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2241802644de85098b955b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f77de653e990d08e5ba288e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75fec31f21125b377344e3d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8117367ed587705966ca4156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d3a739a14dd39bc224b2740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_60b30cf08542ed5e637c4365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9a8ee37935a4ee6eae3259a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_1ac3bd8bd006af496b1ba73d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-3fbe-73fb-8a3a-f02d48e15b4b.webp",
      "image_media": {
        "alt_text": "The Retreat at Eldridge Apartment Homes logo with SatisFacts 2012 Superior Resident Satisfaction Company Award",
        "public_id": "019d4e83-3fbe-73fb-8a3a-f02d48e15b4b",
        "storage_key": "property/6767906449162905/019d4e83-3fbe-73fb-8a3a-f02d48e15b4b.webp",
        "width": 180,
        "height": 120
      },
      "title": "Logo",
      "description": "The Retreat at Eldridge Apartment Homes logo and SatisFacts 2012 Superior Resident Satisfaction Company Award.",
      "link": "false",
      "alt_text": "The Retreat at Eldridge Apartment Homes logo with SatisFacts 2012 Superior Resident Satisfaction Company Award",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SUDIjGDp_CMinNX9HsuRg69sheKjjMQTXm12HTnnq_0/102/image.jpg"
    },
    {
      "id": "ec_83c79bea0b61c18f477efcac",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-f849-7466-b6df-17816a531771.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfddc-f849-7466-b6df-17816a531771",
        "storage_key": "property/6767906449162905/019cfddc-f849-7466-b6df-17816a531771.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1XIiHE-av6MwruJFgP89UrPQak7MrVmZRXHHH84wqeg/102/image.jpg"
    },
    {
      "id": "ec_fef43123c1c53078542fed1a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-f8b9-71f0-bb25-bd77a4e6bfaa.webp",
      "image_media": {
        "alt_text": "Modern lounge area with large windows overlooking a pool, featuring a curved orange sofa and contemporary decor.",
        "public_id": "019cfddc-f8b9-71f0-bb25-bd77a4e6bfaa",
        "storage_key": "property/6767906449162905/019cfddc-f8b9-71f0-bb25-bd77a4e6bfaa.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Experience sophisticated relaxation in our beautifully designed community lounge, complete with ample seating and stunning pool views.",
      "link": "false",
      "alt_text": "Modern lounge area with large windows overlooking a pool, featuring a curved orange sofa and contemporary decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/paj7K1nyb7aIIn-UwDModJ75WPiCm5XJxjRIMeCSq7A/110/image.jpg"
    },
    {
      "id": "ec_7eab821735e386c49918fc66",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d07f5-ee2d-747f-b5c5-6706c4b2977b.webp",
      "image_media": {
        "alt_text": "Community lounge with a long desk, chairs, and a meeting table.",
        "public_id": "019d07f5-ee2d-747f-b5c5-6706c4b2977b",
        "storage_key": "property/6767906449162905/019d07f5-ee2d-747f-b5c5-6706c4b2977b.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "This community space features a long desk area with chairs and a TV, perfect for remote work or studying. A meeting table with chairs is also available for resident use.",
      "link": "false",
      "alt_text": "Community lounge with a long desk, chairs, and a meeting table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/f2XwT6BnGQt9kAh3xAOL1ybvkp99cu6ZkHB_R7ImMTc/106/image.jpg"
    },
    {
      "id": "ec_fb6b884a665be3160932c25b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-ff99-714a-99e6-2034543eb02d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019cfddc-ff99-714a-99e6-2034543eb02d",
        "storage_key": "property/6767906449162905/019cfddc-ff99-714a-99e6-2034543eb02d.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight training equipment, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/p5FZnasyn_NICi1rmaugE0sBYN5-b7h2oXyPpnJWQSk/110/image.jpg"
    },
    {
      "id": "ec_5890ca172f20bd628daad82a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-5489-70ff-ba0f-b39d41223eaf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
        "public_id": "019d4e83-5489-70ff-ba0f-b39d41223eaf",
        "storage_key": "property/6767906449162905/019d4e83-5489-70ff-ba0f-b39d41223eaf.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant quartz countertops. Perfect for culinary adventures.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hPYUB9DhPmpn2UDMlrvzhMyOIElHycpVP4inxeZnBTA/105/image.jpg"
    },
    {
      "id": "ec_98252802bad01db89d680f70",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0514-723b-ae95-ef42eac215a8.webp",
      "image_media": {
        "alt_text": "Living room with view of laundry closet containing a washer and dryer.",
        "public_id": "019cfddd-0514-723b-ae95-ef42eac215a8",
        "storage_key": "property/6767906449162905/019cfddd-0514-723b-ae95-ef42eac215a8.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and convenient in-unit laundry closet featuring a washer and dryer.",
      "link": "false",
      "alt_text": "Living room with view of laundry closet containing a washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dDBeIoMdwwfcuQoTAqRO9yXdWQGZSRbRlsU-1s_xmJ8/110/image.jpg"
    },
    {
      "id": "ec_86175fb38e0b7eb4094b3e95",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-4d27-70fe-9ec5-0c63f16b9569.webp",
      "image_media": {
        "alt_text": "Phillips Pass Apartment Homes outdoor swimming pool with lounge chairs and grilling area.",
        "public_id": "019d4e83-4d27-70fe-9ec5-0c63f16b9569",
        "storage_key": "property/6767906449162905/019d4e83-4d27-70fe-9ec5-0c63f16b9569.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and outdoor grilling area at Phillips Pass Apartment Homes. Relax on our comfortable lounge chairs and soak up the sun.",
      "link": "false",
      "alt_text": "Phillips Pass Apartment Homes outdoor swimming pool with lounge chairs and grilling area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7ASgR9CxEVqBcgXAPmnypqWvrIFRZFiBC-n5O_s89vI/102/image.jpg"
    },
    {
      "id": "ec_3d33fb6fa2c752a1ced448ba",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-f849-7466-b6df-17816a531771.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfddc-f849-7466-b6df-17816a531771",
        "storage_key": "property/6767906449162905/019cfddc-f849-7466-b6df-17816a531771.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1XIiHE-av6MwruJFgP89UrPQak7MrVmZRXHHH84wqeg/102/image.jpg"
    },
    {
      "id": "ec_0695dc95c83beb417311c5af",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0a62-71ed-9569-1335a72a6be6.webp",
      "image_media": {
        "alt_text": "Exterior view of a blue and white multifamily apartment building with balconies and manicured landscaping.",
        "public_id": "019cfddd-0a62-71ed-9569-1335a72a6be6",
        "storage_key": "property/6767906449162905/019cfddd-0a62-71ed-9569-1335a72a6be6.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Charming exterior view of the apartment complex, showcasing its blue and white facade, private balconies, and beautiful green spaces.",
      "link": "false",
      "alt_text": "Exterior view of a blue and white multifamily apartment building with balconies and manicured landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/PmjpKdlVmpeFX_X7Q-DmqX0vopQnm4LG1G9OG_r8xZA/119/image.jpg"
    },
    {
      "id": "ec_23bb7bace1b77d1310844116",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-1350-777c-bd45-a6eb51ac0c98.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019cfddd-1350-777c-bd45-a6eb51ac0c98",
        "storage_key": "property/6767906449162905/019cfddd-1350-777c-bd45-a6eb51ac0c98.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Relax by our sparkling resort-style swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/wpm8OglFi65BgHyEMWl6oGddtRiYEWo5N67Cm5D97ao/102/image.jpg"
    },
    {
      "id": "ec_1f046dc5825c41f1bdf95755",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-11ed-726b-89b0-710f228ec412.webp",
      "image_media": {
        "alt_text": "Playground area with a slide and climbing structure, benches, and trees.",
        "public_id": "019cfddd-11ed-726b-89b0-710f228ec412",
        "storage_key": "property/6767906449162905/019cfddd-11ed-726b-89b0-710f228ec412.webp",
        "width": 2000,
        "height": 1498
      },
      "title": "Community",
      "description": "Enjoy our community's outdoor playground, perfect for family fun and recreation. Features a play structure with slide, benches for relaxation, and shaded areas.",
      "link": "false",
      "alt_text": "Playground area with a slide and climbing structure, benches, and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CgXv1jwCQ_q53j2_4pxzcOJKhUZVP42He71ssosKeJI/119/image.jpg"
    },
    {
      "id": "ec_575ecbea8aaf146d8761944f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0ff1-72d2-8ab3-d0b8955d04f4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, quartz countertops, and a dining area with a glass table and white chairs.",
        "public_id": "019cfddd-0ff1-72d2-8ab3-d0b8955d04f4",
        "storage_key": "property/6767906449162905/019cfddd-0ff1-72d2-8ab3-d0b8955d04f4.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Stylish apartment kitchen featuring a breakfast bar, stainless steel appliances, and a separate dining space perfect for everyday meals or entertaining guests.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, quartz countertops, and a dining area with a glass table and white chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/bMmWIPCMOyFwRCmyp9t1YPV1SA1JQGsdrpCksPQp6aQ/102/image.jpg"
    },
    {
      "id": "ec_c1f02b44bc5f142f46495e53",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-17fb-777e-8ae7-0caaf5f9580a.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with steps and railings, surrounded by a paved patio and lush greenery. A white building with large windows and a blue building are visible in the background.",
        "public_id": "019cfddd-17fb-777e-8ae7-0caaf5f9580a",
        "storage_key": "property/6767906449162905/019cfddd-17fb-777e-8ae7-0caaf5f9580a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool. Perfect for relaxation and fun, complete with comfortable seating and a vibrant atmosphere.",
      "link": "false",
      "alt_text": "Sparkling blue swimming pool with steps and railings, surrounded by a paved patio and lush greenery. A white building with large windows and a blue building are visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qdRuaM7rMMx_Y1m-E9e5rijDOWxNeU1yWF07seagzIE/119/image.jpg"
    },
    {
      "id": "ec_6df084dd86c08ba2fb38d572",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-6688-713a-ab20-643c93865b7c.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019d4e83-6688-713a-ab20-643c93865b7c",
        "storage_key": "property/6767906449162905/019d4e83-6688-713a-ab20-643c93865b7c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide selection of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RcdKeIzF1sgezbnzHexjxK1oXJp1UBJO2M3Ewhao1Vo/102/image.jpg"
    },
    {
      "id": "ec_1e96c52486908eed271ab4ef",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-22a5-747c-93bc-2143bec40bb4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and grey cabinets.",
        "public_id": "019cfddd-22a5-747c-93bc-2143bec40bb4",
        "storage_key": "property/6767906449162905/019cfddd-22a5-747c-93bc-2143bec40bb4.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "A beautifully designed kitchen featuring stainless steel appliances, ample counter space, and elegant cabinetry, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white countertops, and grey cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/bRuTuc3ag1EEHZ1DRK8_4IxzjjzAUwftkU8UAwTmJ50/118/image.jpg"
    },
    {
      "id": "ec_3eea45282bc69e69350e3a8b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-239a-7709-9c71-23686dac9400.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, bedside tables, and a dresser.",
        "public_id": "019cfddd-239a-7709-9c71-23686dac9400",
        "storage_key": "property/6767906449162905/019cfddd-239a-7709-9c71-23686dac9400.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious and well-decorated bedroom featuring a king-size bed, plush carpeting, and ample natural light.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, bedside tables, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fO1R6Vl1WHPvgA_fDDf-Ke2rZz4C9qk4E0zGFUe0Cn4/102/image.jpg"
    },
    {
      "id": "ec_c87e3f5696c577421fedb030",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-280b-7439-a1e7-b3273dc84388.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a walking path, lush greenery, and trees.",
        "public_id": "019cfddd-280b-7439-a1e7-b3273dc84388",
        "storage_key": "property/6767906449162905/019cfddd-280b-7439-a1e7-b3273dc84388.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stroll through our beautifully landscaped courtyard, featuring winding paths, mature trees, and vibrant green spaces, creating a serene atmosphere.",
      "link": "false",
      "alt_text": "Apartment complex courtyard with a walking path, lush greenery, and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/lg5IuCnMJZ0mPvgtF0WcHyf-F8RXplFQRx4v-ZzxEhs/119/image.jpg"
    },
    {
      "id": "ec_d1c17e9f7ee64c525fa06912",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-7b44-7310-a146-dc733c27cc5e.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with grills and seating",
        "public_id": "019d4e83-7b44-7310-a146-dc733c27cc5e",
        "storage_key": "property/6767906449162905/019d4e83-7b44-7310-a146-dc733c27cc5e.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy the resort-style pool, perfect for relaxing or entertaining, complete with convenient grilling stations.",
      "link": "false",
      "alt_text": "Outdoor pool area with grills and seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CVz9Chez0Xxq7-mT1SXkTxGdD42R6t4Mqp_H3dJyoL0/102/image.jpg"
    },
    {
      "id": "ec_8cccbf5167345c96767418aa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-3106-761a-a5c0-97e2d6d2475c.webp",
      "image_media": {
        "alt_text": "Closet laundry room with washer and dryer",
        "public_id": "019cfddd-3106-761a-a5c0-97e2d6d2475c",
        "storage_key": "property/6767906449162905/019cfddd-3106-761a-a5c0-97e2d6d2475c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer closet for convenient laundry access.",
      "link": "false",
      "alt_text": "Closet laundry room with washer and dryer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZJgJQ6xrKsJ4q6ROaSMMjqduBaAkWk6bYOZaDeGYw1U/119/image.jpg"
    },
    {
      "id": "ec_ad08bba72ebf134404e8d632",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-303a-70ca-8b49-a09c79de3c38.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, coffee table, TV, and bar stools at kitchen counter.",
        "public_id": "019cfddd-303a-70ca-8b49-a09c79de3c38",
        "storage_key": "property/6767906449162905/019cfddd-303a-70ca-8b49-a09c79de3c38.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living area. Perfect for relaxing or entertaining, featuring a plush sofa, entertainment center, and a sleek kitchen island with bar seating.",
      "link": "false",
      "alt_text": "Modern living room with sofa, coffee table, TV, and bar stools at kitchen counter.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tKDkWlS1KL7wfXRQ1oA-c10HGpO8e_nNdZWwayEO_FU/102/image.jpg"
    },
    {
      "id": "ec_47ce6710cb1059d312b7bd6c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-344b-737e-8d74-beca6d8f1fff.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white shelving and hanging rods.",
        "public_id": "019cfddd-344b-737e-8d74-beca6d8f1fff",
        "storage_key": "property/6767906449162905/019cfddd-344b-737e-8d74-beca6d8f1fff.webp",
        "width": 1334,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with white shelving and hanging rods.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/eqbAnKfLfD2K-c9zdn7vqCYYvUTrkpmsfzNuSohXXNw/119/image.jpg"
    },
    {
      "id": "ec_fa4d1a6cbf07cbb3aec66ead",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-a85b-761a-9449-901ed88c2b5c.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a well-lit gym with large windows overlooking a pool and trees.",
        "public_id": "019d4e83-a85b-761a-9449-901ed88c2b5c",
        "storage_key": "property/6767906449162905/019d4e83-a85b-761a-9449-901ed88c2b5c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, ellipticals, and other cardio machines. Enjoy your workout with a view of the pool and lush greenery.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a well-lit gym with large windows overlooking a pool and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/O3XIt90weX4hYlx1LXxQaqWiaag2Li46bN2QEOwPZLk/102/image.jpg"
    },
    {
      "id": "ec_af8fd2d8eece048dcdddad6a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-41cf-7309-a180-4b27da832b48.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, TV, and decorative items.",
        "public_id": "019cfddd-41cf-7309-a180-4b27da832b48",
        "storage_key": "property/6767906449162905/019cfddd-41cf-7309-a180-4b27da832b48.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious and modern living room featuring a comfortable sectional sofa, a sleek entertainment center with a mounted TV, and stylish decorative accents.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, TV, and decorative items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/CLVtAbRI-f9NUTcnl9Z1pCRnVggEvRDGCiJF0rJ2fDk/119/image.jpg"
    },
    {
      "id": "ec_59af3e2d21042920cbba8ed9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-3e11-71ff-befd-c34a7858f0d6.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a rug.",
        "public_id": "019cfddd-3e11-71ff-befd-c34a7858f0d6",
        "storage_key": "property/6767906449162905/019cfddd-3e11-71ff-befd-c34a7858f0d6.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on this spacious balcony, perfect for relaxation and enjoying the outdoors.",
      "link": "false",
      "alt_text": "Balcony with two chairs and a rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/s0_-NxbpxbSZPyZkyH7O91-wDNjDB7FkqkOciu7gpnY/102/image.jpg"
    },
    {
      "id": "ec_fcb3069371f2d90908d6e500",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-3f85-71d5-b2df-507d97536c01.webp",
      "image_media": {
        "alt_text": "Community kitchen with bar seating and view of the pool.",
        "public_id": "019cfddd-3f85-71d5-b2df-507d97536c01",
        "storage_key": "property/6767906449162905/019cfddd-3f85-71d5-b2df-507d97536c01.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Gather in our community kitchen, complete with modern appliances, ample counter space, and bar seating. Enjoy the view of the refreshing outdoor pool from the adjacent lounge area.",
      "link": "false",
      "alt_text": "Community kitchen with bar seating and view of the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/I1KtuqT44B9bPGrxyVMZqLAOm8MmV0uhKeOJFrb_sqk/114/image.jpg"
    },
    {
      "id": "ec_89aed51f16204f726da9dcf2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-41f8-71b2-853a-cabbcf466926.webp",
      "image_media": {
        "alt_text": "A spacious living room and kitchen area in a modern apartment, featuring a sofa, chairs, TV, and dining table.",
        "public_id": "019cfddd-41f8-71b2-853a-cabbcf466926",
        "storage_key": "property/6767906449162905/019cfddd-41f8-71b2-853a-cabbcf466926.webp",
        "width": 2000,
        "height": 1337
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, showcasing a seamless flow between the living area, dining space, and a fully equipped kitchen.",
      "link": "false",
      "alt_text": "A spacious living room and kitchen area in a modern apartment, featuring a sofa, chairs, TV, and dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/r41xhgTl8CEQ1517Mw4KIT--23iJFLmlC8_JcmaDcj0/119/image.jpg"
    },
    {
      "id": "ec_3008faecabfb38a3d6258d86",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-4d87-7778-8546-a4c77d488e3b.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge seating and palm trees.",
        "public_id": "019cfddd-4d87-7778-8546-a4c77d488e3b",
        "storage_key": "property/6767906449162905/019cfddd-4d87-7778-8546-a4c77d488e3b.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. Lounge chairs and shaded areas provide ultimate comfort.",
      "link": "false",
      "alt_text": "Swimming pool with lounge seating and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Nbh3OSP-AK76AFHKdmakRQGdjUTxjcf8KaA0HIkf2Vo/112/image.jpg"
    },
    {
      "id": "ec_029f3b5405c98b23ef302b1d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-4f23-73cc-9a5f-25068007a66d.webp",
      "image_media": {
        "alt_text": "A well-lit apartment interior featuring a desk area with a computer and a small dining area with a glass table.",
        "public_id": "019cfddd-4f23-73cc-9a5f-25068007a66d",
        "storage_key": "property/6767906449162905/019cfddd-4f23-73cc-9a5f-25068007a66d.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Discover a functional and stylish living space in this apartment, complete with a dedicated desk area and a charming dining nook.",
      "link": "false",
      "alt_text": "A well-lit apartment interior featuring a desk area with a computer and a small dining area with a glass table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dXH8BV1tl3Tah23J2gObxnuXWebh8-H-Ss8ndLrWK3U/119/image.jpg"
    },
    {
      "id": "ec_6bb9dafba85c5d39db0c81d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-4f25-756f-9fb2-57314ec4cad0.webp",
      "image_media": {
        "alt_text": "Study and lounge area with desks and chairs.",
        "public_id": "019cfddd-4f25-756f-9fb2-57314ec4cad0",
        "storage_key": "property/6767906449162905/019cfddd-4f25-756f-9fb2-57314ec4cad0.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "A comfortable study and lounge area featuring multiple workstations, plush seating, and decorative shelving, perfect for residents to work or relax.",
      "link": "false",
      "alt_text": "Study and lounge area with desks and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/gWPAJEdsuGDx5k4-Tz9kLmzl_E1voE7DKAb8cMx2wbI/102/image.jpg"
    },
    {
      "id": "ec_54a9534169403388cda7833a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-524c-75d8-a535-425640a3f2f9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, navy blue headboard, decorative pillows, and bedside tables.",
        "public_id": "019cfddd-524c-75d8-a535-425640a3f2f9",
        "storage_key": "property/6767906449162905/019cfddd-524c-75d8-a535-425640a3f2f9.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Chic and cozy bedroom featuring a plush navy blue bed with decorative pillows and soft throws, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-sized bed, navy blue headboard, decorative pillows, and bedside tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/olzIiRGWQg9dbV-0SCn4u3WvwiqQD4uDcM6Kd8JRJkQ/119/image.jpg"
    },
    {
      "id": "ec_3d2ba697c6b4a1aecd48d7fd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-eeee-720a-9bac-57d5fd08f22a.webp",
      "image_media": {
        "alt_text": "Spacious and well-equipped fitness center with weight machines, free weights, and cardio equipment.",
        "public_id": "019d4e83-eeee-720a-9bac-57d5fd08f22a",
        "storage_key": "property/6767906449162905/019d4e83-eeee-720a-9bac-57d5fd08f22a.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Stay active and reach your fitness goals in our state-of-the-art fitness center, featuring a comprehensive selection of cardio machines, weight training equipment, and free weights.",
      "link": "false",
      "alt_text": "Spacious and well-equipped fitness center with weight machines, free weights, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/IEecDd0y5YqMml6cC5RVg-XCRGBgmCpSbuHFNuF2VX4/102/image.jpg"
    },
    {
      "id": "ec_90dfccc2aa91a91791318a8a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-5c8d-7771-8b57-a1ab30111cd4.webp",
      "image_media": {
        "alt_text": "A modern living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfddd-5c8d-7771-8b57-a1ab30111cd4",
        "storage_key": "property/6767906449162905/019cfddd-5c8d-7771-8b57-a1ab30111cd4.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room, featuring a comfortable sectional sofa, plush armchair, and a chic coffee table, perfect for entertaining or unwinding.",
      "link": "false",
      "alt_text": "A modern living room with a sectional sofa, armchair, and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cpzX1X5nYsPhcLFmcdYEBNhBJnnmDfKv68jZpT-3Lzo/116/image.jpg"
    },
    {
      "id": "ec_6fcb11c505f2f32acd8a0a09",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-5bab-70d9-98cf-5ae731dd2737.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar with stools.",
        "public_id": "019cfddd-5bab-70d9-98cf-5ae731dd2737",
        "storage_key": "property/6767906449162905/019cfddd-5bab-70d9-98cf-5ae731dd2737.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring modern stainless steel appliances, ample cabinet space, and a stylish breakfast bar perfect for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mwTftJpdBY4pFtbEkSSuDBv0GiyU6b3zwdNSX6BPuhs/102/image.jpg"
    },
    {
      "id": "ec_5cb8f9fadd8c02ca17933df9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-60f5-7520-9913-5b30faeaf9e3.webp",
      "image_media": {
        "alt_text": "Lobby with fireplace and seating area overlooking pool.",
        "public_id": "019cfddd-60f5-7520-9913-5b30faeaf9e3",
        "storage_key": "property/6767906449162905/019cfddd-60f5-7520-9913-5b30faeaf9e3.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Elegant lobby space with comfortable seating, a fireplace, and large windows offering views of the resort-style pool area.",
      "link": "false",
      "alt_text": "Lobby with fireplace and seating area overlooking pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/SQO-E7wHMM3UMX5a1Cr-HqYsLa5yRHKIwePxVh5CHTY/116/image.jpg"
    },
    {
      "id": "ec_088b6b6e778256394f81e863",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-68ae-736d-b032-2edf79d06174.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a gray vanity, white countertop, stainless steel sink and faucet, large mirror, and a bathtub with a white shower curtain.",
        "public_id": "019cfddd-68ae-736d-b032-2edf79d06174",
        "storage_key": "property/6767906449162905/019cfddd-68ae-736d-b032-2edf79d06174.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Step into this modern bathroom featuring a spacious vanity with ample counter space, a large mirror, and a clean white bathtub with a shower.",
      "link": "false",
      "alt_text": "Modern bathroom with a gray vanity, white countertop, stainless steel sink and faucet, large mirror, and a bathtub with a white shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Gmjw9-_m4sQda3JqYHuL-lq2qgCKe9B0aaN48-VGkUw/102/image.jpg"
    },
    {
      "id": "ec_daeba2a47eaeb62cf8a83357",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019d4e83-ccac-7538-bdf5-ebbcdd21b59f.webp",
      "image_media": {
        "alt_text": "Wimberly Black subdivision lot map",
        "public_id": "019d4e83-ccac-7538-bdf5-ebbcdd21b59f",
        "storage_key": "property/6767906449162905/019d4e83-ccac-7538-bdf5-ebbcdd21b59f.webp",
        "width": 216,
        "height": 346
      },
      "title": "Floorplan",
      "description": "Map of the Wimberly Black subdivision, Lot 119-062-001-0001. Shows lot dimensions and acreage.",
      "link": "false",
      "alt_text": "Wimberly Black subdivision lot map",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/usfxZBkz2IzZMsMT_XVsnM5sqIkMjt4jIeVFu-_qatw/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_7ce03041654f348a236c9813",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "poi_name": "Ray Daily Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a01390bfd013769941618156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "poi_name": "West Briar Middle",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_1e39a7e0864d9c4c56c0375d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "poi_name": "Westside High School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_f1504e404a76314cc560b16a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "poi_name": "The Village School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_ba82e52434ab44875c83880a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "poi_name": "Primrose School Of Eldridge Parkway",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a9f7a2a7567cbade52f80b0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "poi_name": "Katy Montessori School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_db446ecdff9c01979298031a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "rating": "5",
      "name": "false",
      "text": "This apartment complex is old but not run down. Updated appliances and nice living space. Neighbors are friendly. As a first time mover I was really nervous about the process, but the staff was helpful and worked with me and my roomate. Happy with the outcome. Really affordable. Great maintenance and easy access to Houstons main highway. So blessed and thankful for the move. Making my Apartments a home",
      "date": "false",
      "title": "Oldie but Goodie"
    },
    {
      "id": "ec_169289b4664fce1d0eceafd5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "rating": "4",
      "name": "false",
      "text": "Great place to live, clean and large living area, friendly management.",
      "date": "false",
      "title": "debbie"
    },
    {
      "id": "ec_755647d9b68f8b928bda4cf5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "rating": "4",
      "name": "false",
      "text": "My experience has been great thus far. The property is very quiet, neighbors are nice, I have no  complaints. I feel safe. The office keep you up on the note around the property. The office staff is  very nice.",
      "date": "false",
      "title": "Great "
    },
    {
      "id": "ec_3b59df96a78c9787a21920a0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "rating": "5",
      "name": "false",
      "text": "I have lived at this property for 3 years and am still happy with the decision to live here. The property management changed but they continue to enhance the property with upgrades. The Leasing Manager and staff- Michelle, Aubrey and Mary along with Maintenance Staff members are professional and personable. ",
      "date": "false",
      "title": "Great Place!!!"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f7c32977061abd57a22035e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "LoopNet Video",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/6r3l0r?source=180"
    },
    {
      "id": "ec_5f329b93e903c74d5e8a0a65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-f8b9-71f0-bb25-bd77a4e6bfaa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern lounge area with large windows overlooking a pool, featuring a curved orange sofa and contemporary decor.",
        "public_id": "019cfddc-f8b9-71f0-bb25-bd77a4e6bfaa",
        "storage_key": "property/6767906449162905/019cfddc-f8b9-71f0-bb25-bd77a4e6bfaa.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Resident Clubhouse with Coffee Bar",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=6SyU8gDKdXN"
    },
    {
      "id": "ec_afe9c697cc5ea6936b4853f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-f9eb-76fc-a9ff-4b967c6ba106.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Co-working space with desks, chairs, and a conference table.",
        "public_id": "019cfddc-f9eb-76fc-a9ff-4b967c6ba106",
        "storage_key": "property/6767906449162905/019cfddc-f9eb-76fc-a9ff-4b967c6ba106.webp",
        "width": 984,
        "height": 553
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nPgCcmsQZLC"
    },
    {
      "id": "ec_13add267a72cc8af60425e40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddc-ff99-714a-99e6-2034543eb02d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019cfddc-ff99-714a-99e6-2034543eb02d",
        "storage_key": "property/6767906449162905/019cfddc-ff99-714a-99e6-2034543eb02d.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bj3Fj2Vg7Vh"
    },
    {
      "id": "ec_c543815b3495037df4cd3bae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Efficient 1-bedroom apartment in Houston with 708 sq. ft. of modern living space. Features updated kitchen, spacious bedroom, and refreshed bathroom.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0650-733d-ad6b-f5c32ac63a40.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019cfddd-0650-733d-ad6b-f5c32ac63a40",
        "storage_key": "property/6767906449162905/019cfddd-0650-733d-ad6b-f5c32ac63a40.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "A1 | 1 Bedroom & 1 Bathroom - 708 square feet",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=iunLiQpaXnw"
    },
    {
      "id": "ec_63cde9458f8522627139a6b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162905",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Efficient 810 sq. ft. apartment with modern kitchen, spacious bedroom, and bright living area. Updated finishes and appliances throughout, offering comfort and convenience in a compact Houston residence.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162905/019cfddd-0514-723b-ae95-ef42eac215a8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an apartment living area with a washer and dryer visible through an open doorway.",
        "public_id": "019cfddd-0514-723b-ae95-ef42eac215a8",
        "storage_key": "property/6767906449162905/019cfddd-0514-723b-ae95-ef42eac215a8.webp",
        "width": 984,
        "height": 554
      },
      "virtual_tour_title": "A2 | 1 Bedroom & 1 Bathroom - 810 square feet",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8Xpsm1U55oD"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_text_field",
      "type": "STRING",
      "value": "GTM-P3TMZM2K"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    }
  ],
  "custom_text_field": "GTM-P3TMZM2K",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Rise"
};

export const generatedAt = '2026-10-05T18:31:59.439Z';
